/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 10.6,
    height: 11.1,
    viewBox: '0 0 10.6 11.1',
    data: '<path pid="0" fill-rule="evenodd" d="M10.6 5.5L1.5 11V0l9.1 5.5z"/>'
  }
})
